import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UserData } from 'app/shared/service/UserService';
import * as _ from "underscore";

export interface GameType {
  id: string;
  name: string;
  apiName: string;
  displayName: string;
}

@Injectable({
  providedIn: 'root'
})
export class GameTypeService {
  private gameTypes: GameType[] = [];
  private gameTypesSubject = new BehaviorSubject<GameType[]>([]);
  private apiUrl = ""; // Base API URL
  organizationId:string = ""
  constructor(private http: HttpClient) {
    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != "") this.organizationId = UserData.organizationId;
    else if (!_.isUndefined(localStorage.getItem("organizationId"))) this.organizationId = localStorage.getItem("organizationId");
    this.organizationId = this.organizationId == null ? "noOrg" : this.organizationId;
    this.apiUrl =  UserData.backend_url +  '/v1' +  "/organizations/" + this.organizationId + "/getApps";
    this.loadGameTypes();
  }

  private loadGameTypes() {
    this.http.get(this.apiUrl).pipe(
      map((response: any) => {
        // Map API response to GameType interface
        return response?.Games?.map(game => ({
          id: game.id,
          name: game.name.toLowerCase(),
          apiName: game.name,
          displayName: this.getDisplayName(game.name)
        }));
      })
    ).subscribe(
      (games) => {
        this.gameTypes = games;
        this.gameTypesSubject.next(games);
      },
      (error) => {
        console.error('Error loading game types:', error);
      }
    );
  }

  setGameTypes(types: GameType[]) {
    this.gameTypes = types;
    this.gameTypesSubject.next(types);
  }

  getGameTypes(): Observable<GameType[]> {
    return this.gameTypesSubject.asObservable();
  }

  getGameTypeByName(name: string): GameType | undefined {
    if (!name) return undefined;
    
    return this.gameTypes.find(game => 
      game.name.toLowerCase() === name.toLowerCase() || 
      game.apiName.toLowerCase() === name.toLowerCase() ||
      game.displayName.toLowerCase() === name.toLowerCase()
    );
  }

  getGameTypeById(id: string): GameType | undefined {
    return this.gameTypes.find(game => game.id === id);
  }

  isMatchGame(gameName: string): boolean {
    return gameName?.toLowerCase() === 'match game';
  }

  getDisplayName(gameName: string): string {
    return this.isMatchGame(gameName) ? "Match" : gameName;
  }

  getApiName(gameName: string): string {
    const gameType = this.getGameTypeByName(gameName);
    return gameType?.apiName || gameName;
  }

  getGameName(gameId: string): string {
    const gameType = this.getGameTypeById(gameId);
    return gameType?.name || '';
  }
} 